import { Iata, PlatformThemeId } from './schemas'
import { OpCoMetaConfig } from './types'

const OP_CO_META_CONFIGS: Record<Iata, OpCoMetaConfig> = {
  BA: {
    id: 'british_airways',
    name: 'British Airways',
    programmeIdentifier: 'BAEC',
    localeOptions: ['en-GB', 'en-US'],
    defaultLocale: 'en-GB',
    defaultCountryCode: 'GB',
    defaultCurrencyCode: 'GBP',
    whitelabelTheme: 'british_airways',
    isAviosEnabled: true,
    isMetricOnly: false,
  },
  EI: {
    id: 'aer_lingus',
    name: 'Aer Lingus',
    programmeIdentifier: 'AERC',
    localeOptions: ['en-GB', 'en-US'],
    defaultLocale: 'en-GB',
    defaultCountryCode: 'IE',
    defaultCurrencyCode: 'EUR',
    whitelabelTheme: 'aer_lingus',
    isAviosEnabled: true,
    isMetricOnly: false,
  },
  IB: {
    id: 'iberia',
    name: 'Iberia',
    programmeIdentifier: 'IBP',
    localeOptions: ['es-ES'],
    defaultLocale: 'es-ES',
    defaultCountryCode: 'ES',
    defaultCurrencyCode: 'EUR',
    whitelabelTheme: 'iberia',
    // enabled for now but will have feature flag redirect
    isAviosEnabled: true,
    isMetricOnly: true,
  },
}

export const DEFAULT_OP_CO: Iata = 'BA'
export const DEFAULT_PLATFORM_THEME: PlatformThemeId = 'avios'

export const getOpCoMetaConfig = (iata: Iata): OpCoMetaConfig => OP_CO_META_CONFIGS[iata]

export const isOpCoEnabledForAvios = (iata: Iata) => OP_CO_META_CONFIGS[iata].isAviosEnabled
